import { colors } from '../../styles/theme';
import GuideLayout, { GuideStep } from './GuideLayout';

const servisSteps: GuideStep[] = [
  { id: 1, title: 'Uygulamaya Giriş', description: 'YolSepetiGO uygulamasını açın. Giriş yapın veya yeni hesap oluşturun.', image: '/images/customer-app/1.png' },
  { id: 2, title: 'Servis Seçin', description: 'Ana ekranda "Servis" hizmetine tıklayın. Personel, öğrenci veya organizasyon taşıması.', image: '/images/customer-app/2.png' },
  { id: 3, title: 'Güzergah Girin', description: 'Kalkış ve varış noktalarını, gerekiyorsa ara durakları girin.', image: '/images/customer-app/3.png' },
  { id: 4, title: 'Sefer Detayı', description: 'Yolcu sayısını, tarih/saat ve sefer tipini (tek seferlik veya düzenli) seçin.', image: '/images/customer-app/4.png' },
  { id: 5, title: 'Fiyatı Görün', description: 'Güzergah ve yolcu sayısına göre şeffaf fiyat teklifi görüntülenir. Onaylayın.', image: '/images/customer-app/5.png' },
  { id: 6, title: 'Eşleşme Bekleyin', description: 'Talebiniz gönderildi! Uygun servis aracı ve şoför yönlendirilir.', image: '/images/customer-app/6.png' },
  { id: 7, title: 'Ödeme Yapın', description: 'VISA, MasterCard veya Troy ile güvenli ödeme yapın.', image: '/images/customer-app/7.png' },
  { id: 8, title: 'Seferi Takip', description: 'Servis aracını haritada canlı takip edin. Tahmini varış süresini görün.', image: '/images/customer-app/8.png' },
];

export default function ServisGuidePage() {
  return (
    <GuideLayout
      service="servis"
      poster={{ src: '/images/services/servis.jpg', alt: 'Servis taşımacılığı tanıtımı' }}
      seo={{
        title: 'Servis Talebi Nasıl Oluşturulur?',
        description: 'YolSepetiGO uygulamasından personel, öğrenci ve organizasyon servis taşımacılığı talebi nasıl oluşturulur? Adım adım rehber.',
        keywords: ['servis taşımacılığı', 'personel servisi', 'öğrenci servisi', 'organizasyon taşıma', 'grup taşıma'],
      }}
      breadcrumb="Servis"
      title="Servis Talebi Nasıl Oluşturulur?"
      subtitle="Personel, öğrenci ve organizasyon taşımacılığı için düzenli ve konforlu servis çözümleri."
      accent={{
        from: colors.accent[600],
        to: colors.accent[800],
        soft: colors.accent[50],
        border: colors.accent[200],
        strong: colors.accent[700],
        text: colors.accent[900],
      }}
      steps={servisSteps}
      tipsTitle="Servis Taşımacılığı İpuçları"
      tips={[
        'Düzenli seferler için yolcu sayısını ve güzergahı net belirtin.',
        'Organizasyon taşımalarında etkinlik tarih ve saatini önceden planlayın.',
        'Ara durak ihtiyacınız varsa talep oluştururken ekleyin.',
        'Kurumsal ve toplu talepler için 7/24 destek hattımızı arayabilirsiniz.',
      ]}
      cta={{
        title: 'Servis Taşımacılığına mı İhtiyacınız Var?',
        text: 'Personel, öğrenci veya organizasyon taşımacılığı için hemen talep oluşturun.',
        label: 'Servis Talep Et',
        href: 'https://yolsepetigo.com',
        tone: 'accent',
      }}
    />
  );
}
